import { Box, Button } from '@material-ui/core';
import { Channel } from '@nemuru-eng/js-api-client';

import { Font } from '../../../../../shared/components/Font';
import { Text } from '../../../../../shared/components/Text';

interface AgentFooterProps {
  editModeAllowed: boolean;
  onAddAgent: () => void;
  selectedChannel?: Channel;
}

export const AgentFooter = ({ editModeAllowed, onAddAgent, selectedChannel }: AgentFooterProps) => {
  return (
    <Box mt={2} pr={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <div>
        {editModeAllowed && selectedChannel && (
          <Button
            size={'small'}
            variant={'text'}
            onClick={onAddAgent}
            startIcon={<i className="material-icons-outlined">add</i>}
          >
            <Font variant={'body2'} color={'textSecondary'} style={{ textAlign: 'start' }}>
              <Text tId={'ADD_AGENT_TO_CHANNEL'} dynamicDataTexts={[selectedChannel?.description]} />
            </Font>
          </Button>
        )}
      </div>
      {selectedChannel && (
        <Font variant={'body2'} color={'textSecondary'}>
          <Text
            tId={selectedChannel.agents.length === 1 ? 'NUMBER_OF_AGENT_1' : 'NUMBER_OF_AGENTS'}
            dynamicDataTexts={[selectedChannel.agents.length.toFixed(0)]}
          />
        </Font>
      )}
    </Box>
  );
};
